export default {
  SET_ACTIVE_INBOX(state, payload) {
    state.activeInbox = {
      subInbox: payload.filters && payload.filters.folder ? payload.filters.folder : 'open',
    };
  },
  SET_CURRENT_ASSIGNMENT(state, currentAssignment) {
    state.currentAssignment = currentAssignment;
  },
  SET_CURRENT_FOLDER(state, currentFolder) {
    state.currentFolder = currentFolder;
  },
  SET_INBOX_STATS(state, payload) {
    state.stats = payload;
  },
};
